import React, { useContext } from 'react';
import { Route, Switch } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import Home from 'containers/Home/Home';
import PackageModels from 'containers/PackageModels/PackageModels';
import PackageModel from 'containers/PackageModel/PackageModel';
import { pageLinks } from 'utils/links';
import Interceptor from 'interceptor';
import { ConfigContext } from 'contexts/ConfigContext';
import { THEME_TYPES } from './constants';
import { lightTheme, darkTheme } from 'theme';
import 'App.less';
import ExpiredPackage from 'containers/Errors/ExpiredPackage';
import InvalidCode from 'containers/Errors/InvalidCode';
import Unavailable from 'containers/Errors/Unavailable';
// import useFavicon from 'hooks/useFavicon';

function App() {
  const { clientConfig } = useContext(ConfigContext);
//   useFavicon();
  return (
    <div className="App">
      <Interceptor />
      <Switch>
        <ThemeProvider theme={clientConfig.themeType === THEME_TYPES.DARK ? darkTheme : lightTheme}>
          <Route
            render={() => (
                <Switch>
                  <Route path={`${pageLinks.Home.url}/:code/model/:modelId`} exact component={PackageModel} />
                  <Route path={`${pageLinks.Home.url}/:code`} exact component={PackageModels} />
                  <Route path={`${pageLinks.Home.url}`} exact component={Home} />
                  <Route path={`${pageLinks.ErrorExpired.url}`} exact component={ExpiredPackage} />
                  <Route path={`${pageLinks.ErrorInvalid.url}`} exact component={InvalidCode} />
                  <Route path={`${pageLinks.ErrorUnavailable.url}`} exact component={Unavailable} />
                  <Route path='/' exact component={Home} />
                </Switch>
              )} />
        </ThemeProvider>
      </Switch>
    </div>
  );
}

export default App;
